import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';  // Import Swiper's core CSS
import 'swiper/css/navigation';  // Import Navigation module CSS
import 'swiper/css/effect-fade';  // Import EffectFade module CSS

// Import Swiper modules directly
import {Navigation, EffectFade} from 'swiper/modules';

import {get_ai_models, get_projects, get_services, get_team_members} from "../Utils/Data";
import Service from "./include/Service";
import Project from "./include/Project";
import Team from "./include/Team";
import ContactForm from "./include/ContactForm";
import {Link} from "react-router-dom";
import Tech_Research from "./include/Tech_Research";

function Home() {
    const [services, setServices] = useState([]);
    const [projects, setProjects] = useState([]);
    const [team, setTeam] = useState([]);
    const [ai_models, setAi_models] = useState([]);


    useEffect(() => {
        const fetchServices = async () => {
            const data = await get_services();
            if (data) {
                setServices(data.slice(0, 3));
            }
        };
        const fetchProjects = async () => {
            const data = await get_projects();
            if (data) {
                setProjects(data.slice(0, 4));
            }
        };
        const fetchTeamMembers = async () => {
            const data = await get_team_members();
            if (data) {
                setTeam(data);
            }
        };

        const fetchAi_Models = async () => {
            const data = await get_ai_models();
            if (data) {
                setAi_models(data);
            }
        };
        fetchServices();
        fetchProjects();
        fetchTeamMembers();
        fetchAi_Models()
    }, []);

    return (
        <>
            <Helmet>
                <title>Zaala | Home</title>
            </Helmet>

            <section className="banner-one">
                <Swiper
                    className="banner-slider-one"
                    effect="fade"
                    modules={[Navigation, EffectFade]}  // Register modules here
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    loop={true}
                    fadeEffect={{crossFade: true}}
                >
                    {/* Slide 1 */}
                    <SwiperSlide>
                        <div className="banner-one__single">
                            <div
                                className="shape1"
                                style={{
                                    backgroundImage: 'url(assets/img/shape/banner-v1-shape1.png)',
                                }}
                            ></div>
                            <div className="shape2 float-bob-y">
                                <img src="assets/img/shape/banner-v1-shape2.png" alt=""/>
                            </div>
                            <div className="shape3 rotate-me">
                                <img src="assets/img/shape/banner-v1-shape3.png" alt=""/>
                            </div>
                            <div className="shape4 float-bob-y">
                                <img src="assets/img/shape/banner-v1-shape4.png" alt=""/>
                            </div>
                            <div className="shape5 rotate-me">
                                <img src="assets/img/shape/banner-v1-shape3.png" alt=""/>
                            </div>
                            <div
                                className="banner-one__bg"
                                style={{
                                    backgroundImage: 'url(assets/img/slider/banner-one__bg1.jpg)',
                                }}
                            ></div>
                            <div className="container">
                                <div className="banner-one__content">
                                    <div className="big-title">
                                        <h2>
                                            Empowering<br/> Your{' '}
                                            <a className="button-style-1" href="#">
                                                Discover More <i className="icon-right-arrow-2"></i>
                                            </a>{' '}
                                            Digital <br/> Future
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="banner-one__single">
                            <div
                                className="shape1"
                                style={{
                                    backgroundImage: 'url(assets/img/shape/banner-v1-shape1.png)',
                                }}
                            ></div>
                            <div className="shape2 float-bob-y">
                                <img src="assets/img/shape/banner-v1-shape2.png" alt=""/>
                            </div>
                            <div className="shape3 rotate-me">
                                <img src="assets/img/shape/banner-v1-shape3.png" alt=""/>
                            </div>
                            <div className="shape4 float-bob-y">
                                <img src="assets/img/shape/banner-v1-shape4.png" alt=""/>
                            </div>
                            <div className="shape5 rotate-me">
                                <img src="assets/img/shape/banner-v1-shape3.png" alt=""/>
                            </div>
                            <div
                                className="banner-one__bg"
                                style={{
                                    backgroundImage: 'url(assets/img/slider/banner-one__bg2.jpg)',
                                }}
                            ></div>
                            <div className="container">
                                <div className="banner-one__content">
                                    <div className="big-title">
                                        <h2>
                                            Transforming<br/> Ideas into{' '}
                                            <a className="button-style-1" href="#">
                                                Innovative Solutions <i className="icon-right-arrow-2"></i>
                                            </a>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    {/* Slide 3 */}
                    <SwiperSlide>
                        <div className="banner-one__single">
                            <div
                                className="shape1"
                                style={{
                                    backgroundImage: 'url(assets/img/shape/banner-v1-shape1.png)',
                                }}
                            ></div>
                            <div className="shape2 float-bob-y">
                                <img src="assets/img/shape/banner-v1-shape2.png" alt=""/>
                            </div>
                            <div className="shape3 rotate-me">
                                <img src="assets/img/shape/banner-v1-shape3.png" alt=""/>
                            </div>
                            <div className="shape4 float-bob-y">
                                <img src="assets/img/shape/banner-v1-shape4.png" alt=""/>
                            </div>
                            <div className="shape5 rotate-me">
                                <img src="assets/img/shape/banner-v1-shape3.png" alt=""/>
                            </div>
                            <div
                                className="banner-one__bg"
                                style={{
                                    backgroundImage: 'url(assets/img/slider/banner-one__bg3.jpg)',
                                }}
                            ></div>
                            <div className="container">
                                <div className="banner-one__content">
                                    <div className="big-title">
                                        <h2>
                                            Bridging<br/> Innovation and{' '}
                                            <a className="button-style-1" href="#">
                                                Digital Excellence <i className="icon-right-arrow-2"></i>
                                            </a>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    {/* Repeat other slides as needed */}

                    {/* Navigation buttons */}
                    <div className="main-slider__nav">
                        <div
                            className="swiper-button-prev"
                            tabIndex="0"
                            role="button"
                            aria-label="Previous slide"
                        >
                            <i className="icon-left-arrow-2" aria-hidden="true"></i>
                        </div>
                        <div
                            className="swiper-button-next"
                            tabIndex="0"
                            role="button"
                            aria-label="Next slide"
                        >
                            <i className="icon-right-arrow-2" aria-hidden="true"></i>
                        </div>
                    </div>
                </Swiper>
            </section>

            <div className="services-one pdt0">
                <div className="container">
                    <div className="row">
                        {/*Start Services One Single */}
                        <Service data={services}/>
                        {/*End Services One Single */}
                        <div className="btn-box" style={{backgroundColor: "red"}}>
                            <Link className="button-style-2 " style={{marginLeft: "40%"}} to="/services">
                                MORE SERVICES
                                <i className="icon-plus-1"/>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-one">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6">
                            <div className="about-one__img">
                                <div className="about-one__shape1 float-bob-y">
                                    <img src="assets/img/shape/about-one__shape1.png" alt=""/>
                                </div>
                                <div className="about-one__img-icon">
                                    <a href="about.html">
                                        <span className="icon-plus-1"/>
                                    </a>
                                </div>
                                {/*Start About One Img Top*/}
                                <div className="about-one__img-top">
                                    <ul className="clearfix">
                                        <li>
                                            <div
                                                className="about-one__single-img-box wow  fadeInRight animated"
                                                data-wow-delay="0.1s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.1s",
                                                    animationName: "fadeInRight"
                                                }}
                                            >
                                                <div className="inner">
                                                    <img src="assets/img/about/about-one__img1.jpg" alt=""/>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="about-one__single-img-box wow  fadeInLeft animated"
                                                data-wow-delay="0.1s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.1s",
                                                    animationName: "fadeInLeft"
                                                }}
                                            >
                                                <div className="inner">
                                                    <img src="assets/img/about/about-one__img2.jpg" alt=""/>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                {/*End About One Img Top*/}
                                {/*Start About One Img Bottom*/}
                                <div className="about-one__img-bottom">
                                    <ul className="clearfix">
                                        <li>
                                            <div
                                                className="about-one__single-img-box wow  fadeInRight animated"
                                                data-wow-delay="0.1s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.1s",
                                                    animationName: "fadeInRight"
                                                }}
                                            >
                                                <div className="inner">
                                                    <img src="assets/img/about/about-one__img3.jpg" alt=""/>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="about-one__single-img-box wow  fadeInLeft animated"
                                                data-wow-delay="0.1s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.1s",
                                                    animationName: "fadeInLeft"
                                                }}
                                            >
                                                <div className="inner">
                                                    <img src="assets/img/about/about-one__img4.jpg" alt=""/>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                {/*End About One Img Bottom*/}
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="about-one__content">
                                <div className="section-title tg-heading-subheading animation-style2">
                                    <h5 className="tg-element-title" style={{perspective: 400}}>
                                        <div
                                            className="split-line"
                                            style={{
                                                display: "block",
                                                textAlign: "start",
                                                position: "relative"
                                            }}
                                        >
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    A
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    b
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    o
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    u
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    t
                                                </div>
                                            </div>
                                            {" "}
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    u
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    s
                                                </div>
                                            </div>
                                        </div>
                                    </h5>
                                    <h2 className="tg-element-title" style={{perspective: 400}}>
                                        <div
                                            className="split-line"
                                            style={{
                                                display: "block",
                                                textAlign: "start",
                                                position: "relative"
                                            }}
                                        >
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    E
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    m
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    p
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    o
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    w
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    e
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    r
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    n
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    g
                                                </div>
                                            </div>
                                            {" "}
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    Y
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    o
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    u
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    r
                                                </div>
                                            </div>
                                            {" "}
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    D
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    g
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    t
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    a
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    l
                                                </div>
                                            </div>
                                            {" "}
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    T
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    o
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    m
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    o
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    r
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    r
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    o
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    w
                                                </div>
                                            </div>
                                        </div>
                                    </h2>
                                </div>
                                <div className="about-one__content-text">
                                    <p>
                                        At Zaala Society, we specialize in delivering innovative solutions that empower
                                        businesses to thrive in a rapidly evolving digital landscape. Our expertise
                                        spans across various industries, ensuring that we provide tailored services to
                                        meet the unique needs of each client. With a commitment to excellence, we focus
                                        on enhancing productivity and driving growth through technology.
                                    </p>
                                    <div className="about-one__content-features">
                                        <ul>
                                            <li>
                                                <div className="inner">
                                                    <div className="icon">
                                                        <span className="icon-cloud-migrate-pro"/>
                                                    </div>
                                                    <h3>Software Solutions</h3>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <div className="icon">
                                                        <span className="icon-aI-forge-labs"/>
                                                    </div>
                                                    <h3>Digital Innovations</h3>
                                                </div>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className="bottom-text">
                                        <p>
                                            We deliver innovative solutions for business growth and efficiency.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="blog-two">
                <div className="container">
                    <div className="blog-two__top">
                        <div className="section-title tg-heading-subheading animation-style2">
                            <h5 className="tg-element-title" style={{perspective: 400}}>
                                <div
                                    className="split-line"
                                    style={{
                                        display: "block",
                                        textAlign: "start",
                                        position: "relative"
                                    }}
                                >
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            o
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            u
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            r
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block", marginRight: "10px"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            a
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            i
                                        </div>
                                        {" "}
                                    </div>
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            m
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            o
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            d
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            e
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            l
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            s
                                        </div>
                                    </div>
                                </div>
                            </h5>
                            <h2 className="tg-element-title" style={{perspective: 400}}>
                                <div
                                    className="split-line"
                                    style={{
                                        display: "block",
                                        textAlign: "start",
                                        position: "relative",
                                    }}
                                >
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            A
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            I
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            R
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            E
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            S
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            E
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            A
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            R
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            C
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            H
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            L
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            A
                                        </div>
                                        <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}>
                                            B
                                        </div>
                                    </div>
                                </div>
                            </h2>

                        </div>
                        <div className="btn-box">

                            <Link className="button-style-1" to="/ai-models">
                                More
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        {/*Start Blog One Single */}
                        <Tech_Research data={ai_models.slice(0, 3)}/>
                        {/*End Blog One Single */}
                    </div>
                </div>
            </section>


            <section className="subscribe-one">
                <div className="container">
                    <div className="subscribe-one__inner">
                        <div className="shape1 float-bob-x">
                            <img src="assets/img/shape/subscribe-v1-shape1.png" alt=""/>
                        </div>
                        <div className="title-box text-center tg-heading-subheading animation-style2">
                            <h2 className="tg-element-title" style={{perspective: 400}}>
                                <div
                                    className="split-line"
                                    style={{
                                        display: "block",
                                        textAlign: "center",
                                        position: "relative"
                                    }}
                                >
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            H
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            a
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            v
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            e
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            q
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            u
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            e
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            s
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            t
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            i
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            o
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            n
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            ?
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            F
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            e
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            e
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            l
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        {" "}
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            F
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            r
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            e
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            e
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            T
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            o
                                        </div>
                                    </div>
                                    {" "}
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            A
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            s
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                                transform: "translate(0px, 0px)",
                                                opacity: 1
                                            }}
                                        >
                                            k
                                        </div>
                                    </div>
                                </div>
                            </h2>
                        </div>
                        <form className="subscribe-one__form" action="#">
                            <input type="email" name="email" placeholder="Enter Email"/>
                            <button type="submit" className="button-style-1 secondary-white">
                                <span className="txt">SUSCRIBE</span>
                            </button>
                        </form>
                    </div>
                </div>
            </section>

            <section className="project-one">
                <div className="container-fluid">
                    <div className="section-title text-center tg-heading-subheading animation-style2">
                        <h5 className="tg-element-title" style={{perspective: 400}}>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        a
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        p
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        f
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                </div>
                            </div>
                        </h5>
                        <h2 className="tg-element-title" style={{perspective: 400}}>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        W
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        h
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        I
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        v
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        a
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        M
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                </div>
                                {" "}
                            </div>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    {" "}
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        I
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        T
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        E
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        x
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        c
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        c
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                </div>
                            </div>
                        </h2>
                    </div>
                    <div className="row project-one__gap mx-4">
                        {/*Start Project One Single */}
                        <Project data={projects}/>
                        {/*End Project One Single */}
                    </div>
                </div>
            </section>

            <Team data={team}/>

            <section className="contact-one">
                <div
                    className="contact-one__bg"
                    style={{backgroundImage: "url(assets/img/bg/contact-v1-bg.jpg)"}}
                />
                <div className="container">
                    <div className="contact-one__inner clearfix">
                        <div
                            className="contact-one__form wow fadeInRight"
                            data-wow-delay="200ms"
                            data-wow-duration="1500ms"
                            style={{
                                visibility: "visible",
                                animationDuration: "1500ms",
                                animationDelay: "200ms",
                                animationName: "fadeInRight"
                            }}
                        >
                            <div className="section-title tg-heading-subheading animation-style2">
                                <h5 className="tg-element-title" style={{perspective: 400}}>
                                    <div
                                        className="split-line"
                                        style={{
                                            display: "block",
                                            textAlign: "start",
                                            position: "relative"
                                        }}
                                    >
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                T
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                a
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                l
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                k
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                t
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                u
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                s
                                            </div>
                                        </div>
                                    </div>
                                </h5>
                                <h2 className="tg-element-title" style={{perspective: 400}}>
                                    <div
                                        className="split-line"
                                        style={{
                                            display: "block",
                                            textAlign: "start",
                                            position: "relative"
                                        }}
                                    >
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                U
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                n
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                l
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                a
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                s
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                h
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                t
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                h
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                P
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                w
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                r
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                f
                                            </div>
                                        </div>
                                        {" "}
                                    </div>
                                    <div
                                        className="split-line"
                                        style={{
                                            display: "block",
                                            textAlign: "start",
                                            position: "relative"
                                        }}
                                    >
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            {" "}
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                T
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                c
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                h
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                n
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                l
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                g
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                y
                                            </div>
                                        </div>
                                    </div>
                                </h2>
                            </div>
                            <ContactForm/>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default Home;
